
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const Staff = createAsyncThunk('Staff-list', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const StaffSlice = createSlice({

    name: 'Staff-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [Staff.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [Staff.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [Staff.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = StaffSlice.actions;
export default StaffSlice.reducer